import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { Observable } from 'rxjs';
import { io } from 'socket.io-client';
import { Globals } from '../helpers';
import { HttpInterceptor } from './http-error.interceptor';

@Injectable()
export class SocketService {
  private socket;
  private socketServiceUrl: string;

  constructor(private http: HttpInterceptor, private globals: Globals) {
    this.socketServiceUrl = globals.url + 'c3/';
  }

  public getConnections(filters) {
    const url = this.prepareUrlFilters(this.socketServiceUrl + 'connections', filters);
    return this.http.get(url).map((response: Response) => response.json());
  }
  public getSocket(licenseId) {
    return this.http.get(this.socketServiceUrl + licenseId).map((response: Response) => response.json());
  }
  // now we only get this request for only 1 license
  public getSessions(licenseId, filters) {
    const url = this.prepareUrlFilters(this.socketServiceUrl + licenseId + '/sessions', filters);
    return this.http.get(url).map((response: Response) => response.json());
  }
  public getConnectedSockets(filters?) {
    const url = this.prepareUrlFilters(this.socketServiceUrl, filters);
    return this.http.get(url).map((response: Response) => response.json());
  }

  public sendActionToDevice(licenseId, action, payload?) {
    const data: any = { action };
    if (payload) {
      if (payload.query) { data.query = payload.query; }
      if (payload.body) { data.body = payload.body; }
    }
    return this.http.post(`${this.socketServiceUrl + licenseId}/action`, data)
      .map((response: Response) => response.json());
  }

  public onEvent(event): Observable<any> {
    // test connection to backend on port 8443 without passing in apache reverse proxy
    // const SERVER_URL = `https://localhost:8443/frontend`
    const SERVER_URL = `https://${this.globals.domain}:8443/frontend`;

    if (!this.socket) { this.socket = io(SERVER_URL, { transports: ['websocket'] }); }
    return new Observable<Event>((observer) => {
      this.socket.on(event, (data) => observer.next(data));
    });
  }
  public unsubscribe(event?) {
    if (this.socket) {
      if (event) {
        this.socket.removeListener(event, () => { });
      } else {
        this.socket.removeAllListeners();
      }
    }
  }
  public requestSummaries(licenseId: string) {
    return this.http
      .get(this.socketServiceUrl + licenseId + '/summaries')
      .map((response: Response) => response.json());
  }

  public requestAnalytics(licenseId: string) {
    return this.http
      .get(this.socketServiceUrl + licenseId + '/analytics')
      .map((response: Response) => response.json());
  }

  public requestProxyStatistics(licenseId: string) {
    return this.http
      .get(this.socketServiceUrl + licenseId + '/proxy-statistics')
      .map((response: Response) => response.json());
  }
  public downloadAllLogs(licenseId: string) {
    return this.http
      .get(this.socketServiceUrl + licenseId + '/logs')
      .map((response: Response) => response.json());
  }
  private prepareUrlFilters(url, filters) {
    const params: URLSearchParams = new URLSearchParams();
    if (!filters || !Object.keys(filters).length) { return url; }
    Object.entries(filters).forEach(([key, value]) => {
      params.append(key, value.toString());
    });
    const paramsStr = params.toString();
    if (paramsStr) { url += '?' + paramsStr; }
    return url;
  }
}
